import { render, staticRenderFns } from "./AdminUsersView.vue?vue&type=template&id=c0b3431a&"
import script from "./AdminUsersView.vue?vue&type=script&lang=js&"
export * from "./AdminUsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports